import React from "react";
import RaindropCard from "../raindrop-card/raindrop-card.tsx";

const JSONBlob = ({ data }) => {
  return (
    <RaindropCard isBordered={true}>
      <div className="whitespace-pre-wrap text-left">
        {JSON.stringify(data, null, 2)}
      </div>
    </RaindropCard>
  );
};

export default JSONBlob;
